/* eslint-disable max-lines */
import React, { Component } from "react";
import { Button, Icon, Modal } from "antd";

import { connect } from "react-redux";
import { MultiLevelSelectList } from "../MultiLevelSelectList";
import styles from "./groupMultiLevelSelect.scss";
import {
  fetchMakes,
  fetchSubcategories,
  selectMakes,
  selectSubcategories
} from "../../../routes/Configuration/configuration.ducks";
import { findNodePath, makesToNodes } from "../../../routes/Configuration/helpers";
import { DataSource, isSubcategoryDataSource } from "../../../models/enums";
import { checkEmptyObject } from "../../../services";
import { createDefaultValueObject } from "../../../services/utils";

// Path of the node with the given id as [{ field, value: node }] per level of
// the control chain (make -> model, lv1 -> lv2). Returns true when found.
const findParentTitleArray = (child, nodes, parsedValue, id) => {
  const path = findNodePath(nodes, id);

  if (!path) {
    return false;
  }

  let level = child;
  path.forEach((node, index) => {
    // eslint-disable-next-line no-param-reassign
    parsedValue[index] = { value: node, field: level ? level.field : undefined };
    level = level && level.child;
  });

  return true;
};

class GroupMultiLevelSelect extends Component {
  state = {
    isVisible: false,
    includeConfig: {},
    excludeConfig: {},
    includeSelectedValue: {},
    excludeSelectedValue: {},
    includeSelectedName: [],
    excludeSelectedName: [],
    includeParentIds: [],
    shouldExtendModalWidth: false
  };

  selectedValue = {};

  includeConfig = {};

  excludeConfig = {};

  includeFields = [];

  excludeFields = [];

  constructor(props) {
    super(props);

    if (checkEmptyObject(props.excluded)) {
      this.excludeConfig = {
        title: props.excluded.title,
        dataSource: props.dataSource,
        module: props.module,
        category: props.category,
        tagFormat: props.excluded.tagFormat
      };
    }

    this.includeConfig = {
      title: props.title,
      dataSource: props.dataSource,
      module: props.module,
      category: props.category,
      tagFormat: props.tagFormat
    };
  }

  getChildFields = (child, object) => {
    object.push(child.field);

    if (child.child) {
      this.getChildFields(child.child, object);
    }
  };

  getChild = (child, object, isExclude) => {
    // eslint-disable-next-line no-param-reassign
    object.child = {
      title: child.title,
      field: isExclude ? child.excludedField : child.field,
      chosenValue: child.chosenValue
    };

    if (child.child) {
      this.getChild(child.child, object.child, isExclude);
    }
  };

  componentDidMount() {
    const { value, resources, isMultiRows } = this.props;

    // build config
    this.getChild(this.props.child, this.includeConfig);
    this.getChildFields(this.props.child, this.includeFields);
    if (checkEmptyObject(this.excludeConfig)) {
      this.getChild(this.props.child, this.excludeConfig, true);
      this.getChildFields(this.excludeConfig.child, this.excludeFields);
    }

    if (!resources) {
      this.props.loadResources();
    }

    this.parseValueToEachSelectList(resources, value);

    this.setState({
      excludeConfig: this.excludeConfig,
      includeConfig: this.includeConfig,
      shouldExtendModalWidth:
        !isMultiRows &&
        (this.includeFields.length > 2 || this.excludeFields.length > 2)
    });
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { resources, value } = nextProps;
    if (resources && resources !== this.props.resources) {
      this.parseValueToEachSelectList(resources, value);
    }
  }

  // eslint-disable-next-line max-lines-per-function
  parseValueToEachSelectList = (resources, value) => {
    if (!checkEmptyObject(resources) || !checkEmptyObject(value)) {
      return;
    }

    const keys = Object.keys(value);

    const includeValues = {};
    const excludeValues = {};
    const includeNames = [];
    const excludeNames = [];

    const includeParentIds = [];

    keys.forEach(propName => {
      const ids = value[propName];

      if (!ids || ids.length === 0) {
        return;
      }

      ids.forEach(id => {
        const parsedValue = [];
        const isFound = findParentTitleArray(
          this.props.child,
          resources.children,
          parsedValue,
          id
        );

        if (isFound) {
          if (this.includeFields.includes(propName)) {
            includeNames.push(
              parsedValue
                .filter(v => v)
                .map(v => v.value.name)
                .join("・")
            );
            if (checkEmptyObject(this.excludeConfig)) {
              includeParentIds.push(parsedValue[0].value.id);
            }
          }

          if (this.excludeFields.includes(propName)) {
            excludeNames.push(
              parsedValue
                .filter(v => v)
                .map(v => v.value.name)
                .join("・")
            );
          }
        }
      });

      if (this.includeFields.includes(propName)) {
        includeValues[[propName]] = value[propName];
      }

      if (this.excludeFields.includes(propName)) {
        excludeValues[[propName]] = value[propName];
      }
    });

    this.setState({
      includeSelectedName: includeNames,
      includeSelectedValue: includeValues,
      excludeSelectedName: excludeNames,
      excludeSelectedValue: excludeValues,
      includeParentIds
    });
  };

  handleChangeClick = () => {
    this.setState({
      isVisible: true,
      excludeConfig: this.excludeConfig,
      includeConfig: this.includeConfig
    });

    const { resources, value } = this.props;
    if (resources && checkEmptyObject(value)) {
      this.parseValueToEachSelectList(resources, value);
    }
  };

  handleOk = () => {
    // get multi level name
    const { includeSelectedValue, excludeSelectedValue } = this.state;

    const includeNames = this.generateSelectedNames(
      includeSelectedValue,
      this.includeFields
    );
    const excludeNames = this.generateSelectedNames(
      excludeSelectedValue,
      this.excludeFields
    );

    this.setState({
      includeSelectedName: includeNames,
      excludeSelectedName: excludeNames,
      isVisible: false
    });

    const includeDefault = createDefaultValueObject(this.includeFields);
    const excludeDefault = createDefaultValueObject(this.excludeFields);

    const { onChange, onSubmit } = this.props;

    onChange({
      ...includeDefault,
      ...excludeDefault,
      ...includeSelectedValue,
      ...excludeSelectedValue
    });

    !this.props.isMobile && onSubmit();
  };

  generateSelectedNames = (selectedValue, fields) => {
    const { child, resources } = this.props;
    const names = [];

    if (checkEmptyObject(selectedValue)) {
      const keys = Object.keys(selectedValue);
      keys.forEach(propName => {
        const ids = selectedValue[propName];
        ids.forEach(id => {
          const parsedValue = [];
          const isFound = findParentTitleArray(
            child,
            resources.children,
            parsedValue,
            id
          );

          if (isFound && fields.includes(propName)) {
            names.push(
              parsedValue
                .filter(v => v)
                .map(v => v.value.name)
                .join("・")
            );
          }
        });
      });
    }

    return names;
  };

  handleCancel = () => {
    this.setState({
      isVisible: false,
      includeSelectedValue: {},
      excludeSelectedValue: {},
      excludeConfig: {},
      includeConfig: {}
    });
  };

  handleIncludeChange = value => {
    const { resources, child } = this.props;

    const includeValue = this.removeInvalidValue(value);

    // update include parent id to filter exclude
    const parentIds = [];

    if (checkEmptyObject(this.excludeConfig) && checkEmptyObject(value)) {
      const keys = Object.keys(value);
      keys.forEach(propName => {
        const ids = value[propName];
        ids.forEach(id => {
          const parsedValue = [];
          const isFound = findParentTitleArray(
            child,
            resources.children,
            parsedValue,
            id
          );

          if (isFound && this.includeFields.includes(propName)) {
            parentIds.push(parsedValue[0].value.id);
          }
        });
      });
    }

    this.setState({
      includeSelectedValue: includeValue,
      includeParentIds: parentIds
    });
  };

  handleExcludeChange = value => {
    const excludeValue = this.removeInvalidValue(value);
    this.setState({ excludeSelectedValue: excludeValue });
  };

  removeInvalidValue = value => {
    const validValue = {};
    if (value) {
      const keys = Object.keys(value);
      keys.forEach(propName => {
        const val = value[propName];
        const filteredVal = val.filter(v => v);
        if (filteredVal.length > 0) {
          validValue[propName] = filteredVal;
        }
      });
    }

    return validValue;
  };

  // eslint-disable-next-line complexity,max-lines-per-function
  render() {
    const {
      isVisible,
      includeConfig,
      excludeConfig,
      includeSelectedValue,
      excludeSelectedValue,
      includeSelectedName,
      excludeSelectedName,
      includeParentIds,
      shouldExtendModalWidth
    } = this.state;

    const {
      title,
      isMultiRows,
      isMobile,
      showPlaceholder,
      maxChildren,
      getPopupContainer
    } = this.props;

    let modalStyle = {};
    if (shouldExtendModalWidth) {
      modalStyle.maxWidth = 800;
    } else if (isMobile) {
      modalStyle.top = 0;
      modalStyle.marginBottom = 94;
      modalStyle.paddingBottom = 0;
    } else {
      modalStyle = undefined;
    }

    return (
      <React.Fragment>
        <div className="control-title">{title}</div>
        <div className={styles.selectedLevelTagContainer}>
          {includeSelectedName.map(name => (
            <span className={styles.selectedLevel} key={name}>
              {name}
            </span>
          ))}
        </div>
        <div>
          {excludeSelectedName.map(name => (
            <span className={styles.excludeSelectedLevel} key={name}>
              {name}
            </span>
          ))}
        </div>
        <Button
          className={`uppercase ${styles.changeBtn}`}
          onClick={this.handleChangeClick}
        >
          <Icon type="plus" />
          {"Dodaj"}
        </Button>
        <Modal
          visible={isVisible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText={`${
            !isMobile
              ? "Traži"
              : "Nastaviti"
          }`}
          cancelText={"Otkaži"}
          className={isMobile ? styles.modalMobile : styles.modal}
          width={shouldExtendModalWidth ? "auto" : undefined}
          style={modalStyle}
        >
          {checkEmptyObject(includeConfig) ? (
            <MultiLevelSelectList
              {...includeConfig}
              minimum={1}
              value={includeSelectedValue}
              onChange={this.handleIncludeChange}
              className={styles.dropdown}
              addMoreText={"Dodajte još jedan"}
              wrapClassName={
                isMobile ? styles.selectListMobile : styles.selectList
              }
              isMultiRows={isMultiRows}
              maxChildren={maxChildren}
              getPopupContainer={getPopupContainer}
            />
          ) : null}

          {checkEmptyObject(excludeConfig) ? (
            <React.Fragment>
              <div className={styles.space} />
              <MultiLevelSelectList
                {...excludeConfig}
                minimum={1}
                value={excludeSelectedValue}
                onChange={this.handleExcludeChange}
                className={styles.dropdown}
                parentIds={includeParentIds}
                addMoreText={"Isključite drugu"}
                addMoreIconName="minus"
                wrapClassName={
                  isMobile ? styles.selectListMobile : styles.selectList
                }
                isMultiRows={isMultiRows}
                maxChildren={maxChildren}
                getPopupContainer={getPopupContainer}
              />
            </React.Fragment>
          ) : null}
        </Modal>
      </React.Fragment>
    );
  }
}

GroupMultiLevelSelect.defaultProps = {
  title: "",
  value: {},
  resources: undefined,
  excluded: {},
  isMultiRows: false,
  isMobile: false,
  showPlaceholder: false
};

// Dataset of the control: makes of its category or the subcategory tree of its
// module/category, in the { children: nodes[] } shape the parsing above expects.
function mapStateToProps(state, props) {
  let nodes;

  if (props.dataSource === DataSource.make) {
    const makes = selectMakes(state, props.category);
    nodes = makes ? makesToNodes(makes) : undefined;
  } else if (isSubcategoryDataSource(props.dataSource)) {
    nodes = selectSubcategories(state, props.module, props.category);
  }

  return {
    resources: nodes ? { children: nodes } : undefined
  };
}

function mapDispatchToProps(dispatch, props) {
  return {
    loadResources: () => {
      if (props.dataSource === DataSource.make && props.category) {
        dispatch(fetchMakes(props.category));
      } else if (isSubcategoryDataSource(props.dataSource) && props.module && props.category) {
        dispatch(fetchSubcategories(props.module, props.category));
      }
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupMultiLevelSelect);



// WEBPACK FOOTER //
// ./src/components/FormControls/GroupMultiLevelSelect/GroupMultiLevelSelect.js